import {
  type Control,
  type UseFormGetValues,
  type UseFormSetValue,
} from "react-hook-form";
import { bankCardMetadata } from "@features/Budget/budgetConstants";
import { FormCheckbox } from "@components/inputs/form/FormCheckbox/FormCheckbox";
import { type IBudgetNewBank } from "@services/budget/types";
import { type NewBudgetAccountsForm } from "../NewBudgetAccountsModal";

interface INewBudgetBankSectionProps {
  bank: IBudgetNewBank;
  bankIndex: number;
  control: Control<NewBudgetAccountsForm>;
  setValue: UseFormSetValue<NewBudgetAccountsForm>;
  getValues: UseFormGetValues<NewBudgetAccountsForm>;
}

export const NewBudgetBankSection: React.FC<INewBudgetBankSectionProps> = (
  props,
) => {
  const { bank, bankIndex, control, getValues, setValue } = props;
  const metadata = bankCardMetadata[bank.bankName] ?? bankCardMetadata.Default;

  return (
    <div className="flex flex-col gap-1.5">
      <span className="text-sm text-grey-dark">{bank.bankName}</span>
      {bank.bankAccounts.map((account, index) => (
        <div className="rounded-lg border border-grey-light p-3 pr-6">
          <button
            className="flex w-full items-center"
            onClick={() => {
              const key =
                `banks.${bankIndex}.accounts.${index}.isSelected` as const;

              setValue(key, !getValues(key));
            }}
          >
            <div className="flex flex-grow items-center gap-3">
              {metadata.icon && <metadata.icon className="size-10 min-w-10" />}
              <span>{account.iban}</span>
            </div>
            <div>
              <FormCheckbox
                control={control}
                name={`banks.${bankIndex}.accounts.${index}.isSelected`}
              />
            </div>
          </button>
        </div>
      ))}
    </div>
  );
};
